import { getServerInfoAction } from './getServerInfo';

export const serverInfoActions = {
  getServerInfo: getServerInfoAction,
};
